/*******************************************************************************
 *                                                                             *
 * WARNING! This file was automatically generated from the server-side model!  *
 * You shouldn't edit this by hand.  If you want to modify the client-side     *
 * model behavior, you should modify: ../ModelCorrIndQuickInfo.ts              *
 *                                                                             *
/*******************************************************************************/

import { Endpoint, ModelRow, RowConstructor } from "@mcleod/core";

const endpointPath = "lme/ar/corr-ind-quick-info";

export class AutogenModelCorrIndQuickInfo<RowType extends ModelRow> extends Endpoint<RowType, RowCorrIndQuickInfoFields> {
	constructor(ctor: RowConstructor) {
		super(endpointPath, ctor);
	}
}

export class AutogenRowCorrIndQuickInfo extends ModelRow<RowCorrIndQuickInfoFields> {
	constructor(values?: Partial<RowCorrIndQuickInfoFields>) {
		super(endpointPath, true, values);
	}
}

export interface RowCorrIndQuickInfoFields {
	company_id: string;
	description: string;
	element_id: string;
	standard_code: string;
	version: string;
	version: string;
}

